import { render, staticRenderFns } from "./UpgradePlanButton.vue?vue&type=template&id=faa510ec&scoped=true"
import script from "./UpgradePlanButton.vue?vue&type=script&lang=ts"
export * from "./UpgradePlanButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa510ec",
  null
  
)

export default component.exports